import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
export default forwardRef((props, ref) => jsx("svg", {
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    ref,
    ...props,
    dangerouslySetInnerHTML: { __html: '<path d="m5.833 15-1.041 1.042M14.167 15l1.041 1.042M10 7.292V10l1.875 1.875" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" /> <path d="M16.042 10a6.042 6.042 0 1 1-12.084 0 6.042 6.042 0 0 1 12.084 0Zm-.417-6.042.417.417M4.375 3.958l-.417.417" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />' }
  })
);